export default __webpack_public_path__ + "static/media/Table_2.0d4b9b1b.webp";